import { ServerFeature } from '@affine/graphql';

import type { ServerConfig } from './types';

/**
 * Workspaces without the cloud exist only when the server enables them
 * (server config feature.localWorkspace.enabled). Web and desktop follow the
 * same switch; there is no platform exception.
 */
export function isLocalWorkspaceEnabled(config: ServerConfig): boolean {
  return config.features.includes(ServerFeature.LocalWorkspace);
}
